// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visibility_dropdown_container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 4px;
    width: 100%;
    height: 52px;
    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 1;
}

.section_container {
    gap: 4px;
    display: flex;
    flex-direction: column;
}

.visibility_chip {
    width: 165px;
    height: 18px;
    gap: 8px;
    opacity: 1;
    border-radius: 3px;
    padding-top: 2px;
    padding-right: 8px;
    padding-bottom: 2px;
    padding-left: 8px;
}

.distribution_volume_container {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.distribution_volume_form_container {
    width: 100%;
    height: 50px;
    gap: 24px;
    display: flex;
    align-items: center;
}

.distribution_volume_section {
    gap: 10px;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.volume_type_container {
    width: 162px;
    height: 50px;
    gap: 4px;
    opacity: 1;
    display: flex;
    flex-direction: column;
}

.users_selected_container {
    width: 100%;
    gap: 12px;
    display: flex;
    flex-direction: column;
}

.users_selected_name {
    width: 265px;
    height: 32px;
    gap: 8px;
    border-radius: 3px;
    border-width: 1px;
    padding: 8px;
    background-color: #F2F8FA;
    border: 1px solid #A9D5E5;
}

.users_selected_typography {
    font-family: Roboto;
    font-weight: 400px;
    font-style: Regular;
    font-size: 14px;
    line-height: 16px;
    color: #203D48;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/QARuleForm/Audience/Audience.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,SAAS;IACT,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB","sourcesContent":[".visibility_dropdown_container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 0px;\n    gap: 4px;\n    width: 100%;\n    height: 52px;\n    /* Inside auto layout */\n    flex: none;\n    order: 0;\n    flex-grow: 1;\n}\n\n.section_container {\n    gap: 4px;\n    display: flex;\n    flex-direction: column;\n}\n\n.visibility_chip {\n    width: 165px;\n    height: 18px;\n    gap: 8px;\n    opacity: 1;\n    border-radius: 3px;\n    padding-top: 2px;\n    padding-right: 8px;\n    padding-bottom: 2px;\n    padding-left: 8px;\n}\n\n.distribution_volume_container {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.distribution_volume_form_container {\n    width: 100%;\n    height: 50px;\n    gap: 24px;\n    display: flex;\n    align-items: center;\n}\n\n.distribution_volume_section {\n    gap: 10px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.volume_type_container {\n    width: 162px;\n    height: 50px;\n    gap: 4px;\n    opacity: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.users_selected_container {\n    width: 100%;\n    gap: 12px;\n    display: flex;\n    flex-direction: column;\n}\n\n.users_selected_name {\n    width: 265px;\n    height: 32px;\n    gap: 8px;\n    border-radius: 3px;\n    border-width: 1px;\n    padding: 8px;\n    background-color: #F2F8FA;\n    border: 1px solid #A9D5E5;\n}\n\n.users_selected_typography {\n    font-family: Roboto;\n    font-weight: 400px;\n    font-style: Regular;\n    font-size: 14px;\n    line-height: 16px;\n    color: #203D48;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
